@if (enableAPILoading | async) {
  <div id="cover-spin">
    <mat-spinner class="spinner_overlay"></mat-spinner>
  </div>
}
@if (productCode) {
  <form [formGroup]="addToCartForm" (submit)="addToCart()">
    @if (showQuantity) {
      <div class="quantity">
        <udx-product-summary></udx-product-summary>
        <div class="container cart-margin">
          <ng-container>
            <span class="label-font">{{ 'pdp.quantity' | cxTranslate }}</span>
            <div class="row">
              <div class="cx-counter-stock mt-2 mb-4">
                @if (product.maxQty !== undefined) {
                  <app-item-counter
                    [max]="toNumber(product.maxQty)"
                    [min]="product.minQty ? toNumber(product.minQty) : 1"
                    [control]="$any(addToCartForm.get('quantity'))"
                    (quantityChanged)="onQuantityChanged($event,product.hideOnCart)"
                  ></app-item-counter>
                }
                @if (product.maxQty === undefined) {
                  <app-item-counter
                    [min]="product.minQty ? toNumber(product.minQty) : 1"
                    [control]="$any(addToCartForm.get('quantity'))"
                    (quantityChanged)="onQuantityChanged($event,product.hideOnCart)"
                  ></app-item-counter>
                }
              </div>
              @if (validateOutOfStock(product.stock?.stockLevelStatus)) {
                <div class="col m-2">
                  <div class="text-danger">
                    <small class="group-type-age-label"
                      ><b>{{ 'addToCart.outOfStock' | cxTranslate }}</b></small
                      >
                    </div>
                  </div>
                }
                @if (!validateOutOfStock(product.stock?.stockLevelStatus)) {
                  <div class="col m-2">
                    @if(currentBaseSite == 'b2bportal'){
                      <small class="group-type-age-label">
                        @if (product.minQty) {
                          <b>{{ 'common.productMinVal' | cxTranslate : { minVal: product.minQty } }}</b>
                        }
                        @if (product.minQty && product.maxQty) {
                          <b>, </b>
                        }
                        @if (product.maxQty) {
                          <b>{{ 'common.productMaxVal' | cxTranslate : { maxVal: product.maxQty } }}</b>
                        }
                      </small>
                    }
                  </div>
                }
              </div>
            </ng-container>
            <div class="row mt-5">
              @if (product?.annualPassAvailableDates != undefined) {
                <div class="col">
                  <div class="label-font">
                    {{ 'pdp.blockOutDates' | cxTranslate }}
                  </div>
                  <mat-form-field appearance="fill">
                    <mat-label>{{ 'pdp.clickDateIcon' | cxTranslate }}</mat-label>
                    <input matInput [matDatepicker]="blockOut" [matDatepickerFilter]="dateFilter" disabled />
                    <mat-datepicker-toggle matSuffix [for]="blockOut"></mat-datepicker-toggle>
                    <mat-datepicker #blockOut [dateClass]="blockOutDateCell" [disabled]="false"></mat-datepicker>
                  </mat-form-field>
                </div>
              }
              <div class="col">
                <div class="label-font">
                  {{ 'pdp.selectVisitationDate' | cxTranslate }}
                </div>
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'pdp.datelabel' | cxTranslate }}</mat-label>
                  <input
                    matInput
                    [matDatepickerFilter]="dateFilter"
                    (dateChange)="dateSelected($event)"
                    [matDatepicker]="dp"
                    formControlName="datePicker"
                    [class.black-text]="isDateSelected"
                    />
                  <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle()"[class.black-text]="isDateSelected"></mat-datepicker-toggle>
                  <mat-datepicker #dp [disabled]="disableDateSelection()"></mat-datepicker>
                </mat-form-field>
                @if (isLoadingDates) {
                  <mat-spinner></mat-spinner>
                }
              </div>
              <!-- <div class="col" *ngIf="product.timeSelectionRequired">
              <div class="label-font">
                {{ 'pdp.selecttimeslot' | cxTranslate }}
              </div>
              <mat-form-field appearance="fill">
                <mat-label></mat-label>
                <mat-select
                  formControlName="timeSlotPicker"
                  name="time"
                  (selectionChange)="timeSlotSelected($event)"
                  [value]="timeSlots.size === 1 ? getDefaultPerfomance() : null"
                  >
                  <mat-option *ngFor="let time of timeSlots" [value]="time">
                    {{ time }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
          </div>
          @if(usjfeature){
            @if (!this.isExpressContextMainProduct()) {
              <div class="row mt-3 align-items-center">
                <div class="col-lg-8 p-0">
                  <span class="label-font mr-3">{{ 'pdp.attractions' | cxTranslate }}</span>
                </div>
                <div class="col-lg-4 text-end p-0">
                  @if (isExpressContextBaseProduct()) {
                    <button
                      class="btn btn-primary btn-lg select-attractions-button"
                      type="button"
                      (click)="selectAttractions()"
                      [disabled]="attractionSelectionDisabled"
                      >
                      {{ 'pdp.selectattractions' | cxTranslate }}
                    </button>
                  }
                  @if (!isExpressContextBaseProduct()) {
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      (click)="selectAttractions()"
                      >
                      {{ 'pdp.selectattractions' | cxTranslate }}
                    </button>
                  }
                </div>
              </div>
            }
          }
          @if(!usjfeature){
            @if (!this.isExpressContextMainProduct()) {
              <div class="row mt-3">
                <div class="col-lg-12">
                  <span class="label-font mr-5">   {{ 'pdp.attractions' | cxTranslate }}</span>&nbsp;
                  @if (this.isExpressContextBaseProduct()) {
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      (click)="selectAttractions()"
                      [disabled]="attractionSelectionDisabled"
                      >
                      {{ 'pdp.selectattractions' | cxTranslate }}
                    </button>
                  }
                  @if (!this.isExpressContextBaseProduct()) {
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      (click)="selectAttractions()"
                      >
                      {{ 'pdp.selectattractions' | cxTranslate }}
                    </button>
                  }
                </div>
              </div>
            }
          }
          <!-- Value of context: {{ this.expressContext }} -->
          <!-- Timed attractions: {{ getAttractionEventsForKey('TIMED') }} -->
          @if (((this.isExpressContextVariantProduct() || this.isExpressContextMainProduct()) && (this.getCountOfAttractionEventsForKey('TIMED')>0))) {
            <div class="row mt-3">
              <div class="col-12">
                <span class="label-font"> {{ 'pdp.timedAttractions' | cxTranslate }} </span>
                @for (product of getAttractionsForKey('TIMED'); track product) {
                  <mat-dialog-content>
                    <udx-cx-attraction-card-component
                      [product] = "product"
                      [allProducts]= "getAttractionsForKey('TIMED')"
                      [enableSelection]="false"
                      [key] = "'TIMED'"
                      [shouldGroupProducts] = "false"
                    ></udx-cx-attraction-card-component>
                  </mat-dialog-content>
                }
              </div>
            </div>
          }
          <!-- Non-Timed attractions: {{ getAttractionEventsForKey('NON_TIMED') }} -->
          @if (((this.isExpressContextVariantProduct() || this.isExpressContextMainProduct()) && (this.getCountOfAttractionEventsForKey('NON_TIMED')>0))) {
            <div class="row mt-3">
              <div class="col-12">
                <span class="label-font">{{ 'pdp.nonTimedAttractions' | cxTranslate }} </span>
                @for (product of getAttractionsForKey('NON_TIMED'); track product) {
                  <mat-dialog-content>
                    <udx-cx-attraction-card-component
                      [product] = "product"
                      [allProducts]= "getAttractionsForKey('NON_TIMED')"
                      [enableSelection]="false"
                      [shouldGroupProducts]="true"
                      [key]="'NON_TIMED'"
                    ></udx-cx-attraction-card-component>
                  </mat-dialog-content>
                }
              </div>
            </div>
          }
          @if (this.isExpressContextVariantProduct() || this.isExpressContextMainProduct()) {
            <div class="subtotal">{{ 'pdp.subtotal' | cxTranslate }}{{ subtotal | async |currency:defaultCurrencyISO }}</div>
          }
          @if (this.isExpressContextVariantProduct() || this.isExpressContextMainProduct()) {
            <mat-grid-list cols="2" rowHeight="4:1">
              <mat-grid-tile>
                <button class="btn btn-primary btn-block" type="submit" [disabled]="isAddToCartDisabled">
                  {{ 'addToCart.addToCart' | cxTranslate }}
                </button>
              </mat-grid-tile>
              <mat-grid-tile>
                <button class="btn btn-secondary btn-block" [disabled]="isAddToCartDisabled">
                  {{ 'pdp.byNow' | cxTranslate }}
                </button>
              </mat-grid-tile>
            </mat-grid-list>
          }
        </div>
        <!-- Inset here -->
      </div>
    } @else {
      @if (hasStock) {
        <button
          [ngClass]="options.displayAddToCart ? 'link cx-action-link' : 'btn btn-primary btn-block'"
          type="submit"
          [disabled]="quantity <= 0 || quantity > maxQuantity"
          >
          {{ options.addToCartString ?? ('addToCart.addToCart' | cxTranslate) }}
        </button>
      }
    }
  </form>
}
